import { makeStyles } from "@material-ui/core/styles";
import { BREAKPOINT_LG, BREAKPOINT_MD } from "../../../../util/Constants";

export const commonIconStyles = {
  width: "auto",
  height: "auto",
  padding: 1,
  marginRight: 5,
};

export const useStyles = makeStyles((theme) => ({
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: ({ wd }) =>
      wd.width >= BREAKPOINT_LG
        ? "50%"
        : wd.width >= BREAKPOINT_MD
        ? "70%"
        : "99%",
    height: "50vh",
    marginBottom: 20,
    borderRadius: 10,
    padding: 10,
    backgroundColor: `${theme.palette.content.cardsBackground}BB`,
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  titleTextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  tableContainer: {
    maxHeight: "40vh",
    overflowY: "auto",
    width: "100%",
  },
  tableHeader: {
    backgroundColor: theme.palette.content.mainColor,
  },
  statusAppLine: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
  },
  showTableBtn: {
    backgroundColor: `${theme.palette.content.mainColor}CC`,
    padding: 15,
    borderRadius: 10,
    marginBottom: 15,
  },
  showTableTypo: {
    color: "white",
  },
  summaryTypo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  innerInstancesTable: {
    marginLeft: 65,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
    },
  },
}));
